import { msg } from '@lingui/core/macro';

export const CLIENT_NAME_FIELD = 'Name';
export const CLIENT_REPRESENTATIVE_NAME_FIELD = 'ClientRepresentative.Name';
export const CLIENT_REPRESENTATIVE_EMAIL_FIELD = 'ClientRepresentative.Email';
export const CLIENT_REPRESENTATIVE_PHONE_FIELD = 'ClientRepresentative.Phone';
export const BB_REPRESENTATIVE_NAME_FIELD = 'BlueByteRepresentative.Name';
export const BB_REPRESENTATIVE_EMAIL_FIELD = 'BlueByteRepresentative.Email';
export const BB_REPRESENTATIVE_PHONE_FIELD = 'BlueByteRepresentative.Phone';

export const ALLOWED_FIELDS = [
    CLIENT_NAME_FIELD,
    CLIENT_REPRESENTATIVE_NAME_FIELD,
    CLIENT_REPRESENTATIVE_EMAIL_FIELD,
    CLIENT_REPRESENTATIVE_PHONE_FIELD,
    BB_REPRESENTATIVE_NAME_FIELD,
    BB_REPRESENTATIVE_EMAIL_FIELD,
    BB_REPRESENTATIVE_PHONE_FIELD,
];

export const CLIENT_INFO_STEP_TITLE = 'clientInfo';

export const ADMIN_CENTER_ENTITY_TYPE = {
    CLIENT: 'Client',
    REPRESENTATIVE: 'Representative',
} as const;

export const ADMIN_CENTER_FIELD_NAME = {
    NAME: 'Name',
    EMAIL: 'Email',
    PHONE: 'Phone',
} as const;

export const SHARED_CLIENT_INFO_HEADER = msg`Client information`;
export const SHARED_CLIENT_INFO_SUB_INFO = msg`Enter basic information about your organization`;
export const SHARED_CLIENT_INFO_RESPONSIBILITY_HEADER = msg`Responsibility assignment`;
export const SHARED_CLIENT_INFO_RESPONSIBILITY_SUB_INFO = msg`Designate key contacts for subscription management`;
export const SHARED_CLIENT_INFO_CLIENT_REPRESENTATIVE = msg`Client representative`;
export const SHARED_CLIENT_INFO_BLUEBYTE_REPRESENTATIVE = msg`BlueByte representative`;
export const SHARED_CLIENT_INFO_PHONE_LABEL = msg`Phone`;
export const SHARED_CLIENT_INFO_CLIENT_NAME_PLACEHOLDER = msg`Enter company name`;
export const SHARED_CLIENT_INFO_NAME_PLACEHOLDER = msg`Enter name`;
export const SHARED_CLIENT_INFO_EMAIL_PLACEHOLDER = msg`Enter email`;
export const SHARED_CLIENT_INFO_PHONE_PLACEHOLDER = msg`Enter phone`;
export const SHARED_CLIENT_INFO_SAVE = msg`Save`;
